import { Navigate } from 'react-router'

import { useAuth } from '../auth/AuthContext'
import { RequireAuth } from '../auth/RequireAuth'
import { DashboardPage } from '../pages/lazy'

/** `/`: transcoder không có dashboard (API đóng) → danh sách job. */
export function HomeRoute() {
  const { user } = useAuth()
  if (user?.role === 'transcoder') return <Navigate to="/jobs" replace />
  return (
    <RequireAuth role="viewer">
      <DashboardPage />
    </RequireAuth>
  )
}
